/* @fflow */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BiospecimenDownloadContainer } from 'containers/DownloadContainers';
import { Row } from 'components/UIKit/Flex';

export default class BiospecimenToolbar extends Component {
  static propTypes = {
    router: PropTypes.shape({
      params: PropTypes.shape({ entity: PropTypes.string })
    })
  };

  render(): React.Element {
    const { entity } = this.props.router.params;
    const { location: { query: { id } } } = this.props.router;
    return (
      <Row>
        {!id ? (
          <BiospecimenDownloadContainer customDataTestID="button-download-all" type={entity}>
            download all
          </BiospecimenDownloadContainer>
        ) : (
          <BiospecimenDownloadContainer customDataTestID="button-download-all" >
            download all
          </BiospecimenDownloadContainer>
        )}
      </Row>
    );
  }
}
